import FlatIcon from "../FlatIcon";
import classNames from "classnames";

import { getFormattedEventData } from "../../../utils/CleversiteUtilities";
import styles from "./styles/calendar.module.scss";
import { EditButton } from "../../blocks/TerracedGridTheme/EditButton";
import { useMemo } from "react";
import { Moment } from "moment";
import { shortenTextBlock } from "../../../utils/StringUtilities";
import { isTrueMultiDayEvent } from "../../../utils/SchoolBlocksUtilities";
import { IReactiveEventContentItem } from "../../schoolfeed/SchoolFeedContentItem";
import { observer } from "mobx-react";
import { useStores } from "../../../stores/useStores";
import { useTranslateClassName } from "../../../hooks/useTranslateClassName";
import Markdown from "../Markdown";

const Event = observer(
  (props: {
    event: IReactiveEventContentItem;
    currentDate: Moment;
    onEventClick: (event: EventContentItem) => void;
    handleDelete: (contentItem: ContentItem) => void;
  }) => {
    const { interfaceStore, userStore } = useStores();

    const { timeStr, endTime, startTime } = getFormattedEventData(props.event);

    const editButton = (
      <>
        {userStore.isEditor && (
          <EditButton
            handleDelete={props.handleDelete}
            contentItem={props.event}
            className={styles.editButton}
          />
        )}
      </>
    );

    const shouldBeHighlighted = useMemo(() => {
      if (props.event.json_data.event.multi_day) {
        const start = props.event.json_data.event.start;
        const end = props.event.json_data.event.end;
        return props.currentDate.isBetween(start, end, "days", "[]");
      } else {
        return (
          props.currentDate.format("MMM-D-YYYY") ===
          startTime.format("MMM-D-YYYY")
        );
      }
    }, [props.currentDate]);

    const dayEventClassName = classNames({
      [styles.dayEvent]: true,
      [styles.dayEventHidden]: !props.event.published,
      [styles.dayEventCurrentlySelectedDate]: shouldBeHighlighted,
    });
    const translateClassName = useTranslateClassName();

    return (
      <li
        className={dayEventClassName}
        data-start-date={startTime.format("MMM-D-YYYY")}
      >
        <div onClick={() => props.onEventClick(props.event)}>
          {isTrueMultiDayEvent(
            props.event.json_data.event,
            startTime,
            endTime,
          ) ? (
            <div className={`${styles.dayLabel} notranslate`}>
              <div>{startTime.format("MMM")}</div>
              <div>
                {`${startTime.format("D")}-${(endTime as Moment).format("D")}`}
              </div>
            </div>
          ) : (
            <div className={`${styles.dayLabel} notranslate`}>
              <div>{startTime.isValid() ? startTime.format("MMM") : ""}</div>
              <div style={{ fontSize: "2.5rem" }}>
                {startTime.isValid() ? startTime.format("D") : ""}
              </div>
            </div>
          )}
          <div className={styles.eventInfo}>
            <div className={styles.dayContent}>
              <Markdown
                className={classNames(styles.eventTitle, translateClassName)}
                source={props.event.title}
                withStyles={false}
              />
              <div className={classNames("notranslate", styles.timeString)}>
                <FlatIcon name={"flaticon-clock"} />
                {timeStr}
              </div>
            </div>
            {
              <div className={styles.location}>
                <span>{props.event.organization.title}</span>
                {props.event.json_data?.event?.location && (
                  <div className={translateClassName}>
                    <FlatIcon name={"flaticon-location"} />
                    {interfaceStore.breakpoint === "break-point-xs"
                      ? shortenTextBlock(
                          props.event.json_data.event.location,
                          45,
                        )
                      : props.event.json_data.event.location}
                  </div>
                )}
              </div>
            }
          </div>
        </div>
        {editButton}
      </li>
    );
  },
);

export default Event;
